import Gallery from '../src/Gallery';
export default Gallery;
